export default function ($scope, $timeout, siteSearchService, $sce, $document, $constants) {

    //Setting cookie to check whether the browser supports javascript
    document.cookie = "js=true; path=/";

    window.dataLayer = window.dataLayer || [];

    const shouldKeyBeIgnored = e => {
        var k = e.keyCode;
        return e.altKey
            || e.ctrlKey
            || e.shiftKey
            || e.metaKey
            || k === 9
            || !((k === 8)
            || (k >= 48 && k <= 57)
            || (k >= 65 && k <= 90)
            || (k === 27) || (k === 13));
    };

    // global keycode constant
    var KEYCODE_ESC = 27,
        KEYCODE_ENTER = 13,
        KEYCODE_BACKSPACE = 8;

    // extending the jQuery prototype with setCursorPosition
    $.fn.setCursorPosition = function(pos) {

        this.each((index, elem) => {
            if (elem.setSelectionRange) {
                elem.setSelectionRange(pos, pos);
            } else if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        });

        return this;
    }

    //// initializing variables
    var $body = document.querySelector('body');
    var queryString = location.search;

    let searchActive = false;

    $scope.sort = 'rel';
    $scope.pageSize = 10;
    $scope.filter = 'full';
    $scope.pageNumber = 1;
    $scope.reverse = false;
    $scope.optionsActive = false;

    ////

    if (queryString.length) {
        var qs = queryString.substr(1, queryString.length).split('&'),
            tempQuery = '';

        qs.forEach(q => {
            var kvp = q.split('=');
            if (kvp[0] === 'searchType') {
                $scope.filter = kvp[1];
                window.location.hash = $scope.filter;
            } else if (kvp[0] === 'q') {
                tempQuery = kvp[1].replace(/\+/g, '%20');
            }
        });

        $scope.query = decodeURIComponent(tempQuery);
    }

    //Sanitizing html
    $scope.renderHtmlSce = val => $sce.trustAsHtml(val);

    //creating a range for a loop command --ngrepeat--
    $scope.range = function (min, max, step) {
        step = step || 1;
        var input = [];
        for (var i = min; i <= max; i += step) input.push(i);
        return input;
    };

    //submit the search when the query changes and stops bouncing
    $scope.$watch('query', tmpStr => {
        if (tmpStr && tmpStr.length) {
            $scope.model = null;
            submitSearch('full');
        }
    });

    //page setting function
    $scope.pagination = function (page) {
        if ($scope.model && page === 'N') {
            $scope.pageNumber = $scope.pageNumber + 1;
        }
        else if ($scope.model && page === 'P') {
            $scope.pageNumber = $scope.pageNumber - 1;
        } else {
            $scope.pageNumber = Number(page);
        }
        getPage();
    };

    // dismiss the type-to-search alert in the modal
    $scope.closeAlert = function () {
        if ($constants.HAS_LOCALSTORAGE) {
            localStorage['uscHideSearchTip'] = true;
        }

        $scope.showTip = false;
    }

    //return the correct page of results
    function getPage() {
        var from = ($scope.pageNumber - 1) * $scope.pageSize,
            to = from + $scope.pageSize;

        $scope.paged = $scope.model.results.slice(from, to);
        $('html, body').animate({ scrollTop: $('.search-result-status').offset().top }, 100);
    }

    // get results via ajax, avoids page postback/reload
    function submitSearch(type) {
        if ($scope.query && $scope.query.length > 2) {
            const q = $scope.query;

            $body.classList.add('searching');
            $scope.filter = type;

            var count = 50;
            if ($body.classList.contains('overlay-in--search')) {
                count = $scope.filter === 'full' ? 10 : 20;
            }

            $scope.searchDone = false;
            $scope.sidebarDone = $scope.filter !== 'full' ? true : false;

            // always fetch 10 results for modal, 50 for /search - pagination is client side
            siteSearchService.getSearchResults(q, $scope.filter, 1, count)
                .then(data => { 
                    if (data.query === q) {
                        $scope.model = data;
                        $scope.paged = $scope.model.results.slice(0, $scope.pageSize);
                        $scope.searchDone = true;
                    }
                });


            // on full searches, populate the sidebar
            if ($scope.filter === 'full') {
                siteSearchService.getSidebarResults(q, 3)
                    .then(data => { 
                        if (data.query === q) {
                            $scope.newsResults = data.newsResults;
                            $scope.sidebarDone = true;
                        }
                    });
            }
        }
        else {
            $body.classList.remove('searching');
        }
    }

    // remove the loading indicator when both sidebar and main search have resolved.
    // sidebarDone will always be true when the search type is not 'full'
    $scope.$watch('searchDone + sidebarDone', newVal => {
        if (newVal === 2) {
            $timeout(() => $body.classList.remove('searching'), 250);
        }
    });

    // handler for sidebar 'more' links
    $scope.getMore = ($event, type) => {
        $event.preventDefault();
        if (!$body.classList.contains('overlay-in--search')) {
            $scope.filter = type;
            submitSearch(type);
        } else {
            window.location = '/search?q=' + $scope.query + (type !== undefined ? '&searchType=' + type : '');
        }
    }

    // set current search type
    $scope.setActiveType = type => {

        $scope.optionsActive = false;
        $("a[href='#" + $scope.filter + "']").removeClass('active');

        $scope.filter = type;
        $("a[href='#" + type + "']").addClass('active');

        $scope.pageNumber = 1;
        $scope.newsResults = [];

        submitSearch(type);
    };

    // modal search
    if (!$body.classList.contains('search') &&
        !$body.classList.contains('overlay-in--search') &&
        !$body.classList.contains("sitesearch") &&
        !$body.classList.contains("pagenotfound")) {

        // cache variables
        var $searchtext = $('#searchterm'),
            $pattern = /[\w]/;

        // on any keydown, start parsing keyboard input
        $scope.copy = false;
        window.addEventListener('copy', () => $scope.copy = true, false);

        document.addEventListener('paste', e => {
            var oEvent = e.originalEvent;
            var clipText = '';

            if (window.clipboardData) {
                clipText = window.clipboardData.getData('Text');
            } else if (typeof oEvent == 'object' && oEvent.clipboardData) {
                clipText = oEvent.clipboardData.getData('text/plain');
            }

            if (clipText.length > 0) {
                if (!$body.classList.contains('input-focus')) {
                    openSearchModal(clipText);
                    submitSearch();
                }
            }
        });

        document.addEventListener('keydown', e => {
            if (shouldKeyBeIgnored(e)) {
                return;
            }

            if ((searchActive || $body.classList.contains('overlay-in--search')) && e.keyCode === KEYCODE_ESC) {
                closeSearchModal();
                return;
            }

            const keyValue = String.fromCharCode(e.keyCode);
            const keyValid = $pattern.test(keyValue);

            //Not focusing on any input element and not hitting backspace then open search modal
            if (!$scope.copy && !$body.classList.contains('overlay-in--search') &&
                !$body.classList.contains('input-focus') &&
                e.keyCode !== KEYCODE_BACKSPACE &&
                e.keyCode !== KEYCODE_ENTER && keyValid) {
                openSearchModal(keyValid);
            }

            $scope.copy = false;
        });

        const openSearchModal = keyValid => {

            // need to trigger a digest cycle to set the alert visibility
            $scope.$apply(() => {                
                $scope.fromClick = keyValid == undefined;
                $scope.showTip = !$constants.HAS_LOCALSTORAGE || $constants.HAS_LOCALSTORAGE && !localStorage.getItem('uscHideSearchTip');
            });

            if (keyValid) {
                searchActive = true;
                // need to do this to trigger directive link function, to manage classes on icons in menu
                document.querySelector('[overlay-button="search"]').click();
                $searchtext.setCursorPosition($scope.query ? $scope.query.length : 1);
            }
        };

        if (queryString.length && queryString.indexOf('modal') !== -1) {
            var qsValue = queryString.substr(queryString.indexOf('=') + 1).replace(/%20/g, ' ');
            if (qsValue.length) {
                openSearchModal(qsValue);
            }
        }

        for (let a of $body.querySelectorAll('.search-modal li a')) {
            a.on('click', () => {
                // GTM
                dataLayer.push({
                    'event': 'modalSearchEvent',
                    'searchAction': 'Result click',
                    'searchQuery': $scope.query
                });

                history.replaceState(null, null, location.href.substr(0, location.href.indexOf('?')) + '?modal=' + $scope.query);
            });
        }

        const closeSearchModal = () => {
            // GTM
            dataLayer.push({
                'event': 'modalSearchEvent',
                'searchAction': 'Close',
                'searchQuery': $scope.query
            });

            history.replaceState(null, null, location.href.substr(0, location.href.indexOf('?')));
            searchActive = false;
            $scope.query = '';
            document.querySelector('[overlay-button="search"]').click();
        };
    }
};